export default {"src":"/uk/_next/static/media/transferAndContributionBreakdownIcon.6fc40a66.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};